import React, { Component } from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import styles from '../OnboardingRouter/styles.sass';
import SignupForm from '../SignupForm';

import Box from '../../shared/Box';
import { If } from '../../shared/If';
import Text from '../../shared/Text';
import events from '../SignupPageContainer/events';
import { LinkText } from '../../shared/Link';

// This is currently built only for onboarding
class SignupPage extends Component {
  componentDidMount() {
    // Required for Floodlight tagging
    gtag('event', 'conversion', {
      allow_custom_scripts: true,
      send_to: 'DC-9266237/ancho0/spoti00+standard',
    });
  }

  render() {
    const {
      error,
      routing,
      onSubmit,
      anyTouched,
      submitting,
      onClickRequestResetPassword,
    } = this.props;

    const isRedirectedFromRWF =
      queryString.parse(routing.location.search).redirectedFrom === 'rwf';
    return (
      <div className={`${styles.onboardingPage}`}>
        <div className={`${styles.pageContent}`}>
          <Row>
            <Col xs={12}>
              <div className={styles.signupPage}>
                <h1 key="title">
                  {isRedirectedFromRWF
                    ? 'Create an Anchor account'
                    : 'Sign up for Anchor'}
                </h1>
                <Box marginBottom={50} marginTop={12}>
                  <If
                    condition={isRedirectedFromRWF}
                    ifRender={() => (
                      <Text size="xl" color="#7F8287" align="center">
                        Want to make a podcast of your own? Sign up now to get
                        started - it’s 100% free!
                      </Text>
                    )}
                    elseRender={() => (
                      <Text size="xl" color="#292f36">
                        Already have an account?{' '}
                        <Text size="xl" color="#8940fa" isBold isInline>
                          <Link
                            to="/login"
                            onClick={events.signUpSignInButtonClicked}
                          >
                            Log in
                          </Link>{' '}
                        </Text>
                        instead.
                      </Text>
                    )}
                  />
                </Box>
                <SignupForm
                  anyTouched={anyTouched}
                  error={error}
                  onSubmit={onSubmit}
                  routing={routing}
                  submitting={submitting}
                  location={routing.location}
                  onClickRequestResetPassword={onClickRequestResetPassword}
                />
                <If
                  condition={isRedirectedFromRWF}
                  ifRender={() => (
                    <LinkText
                      target="_blank"
                      onClick={() => {}}
                      isInline
                      to="/login"
                      color="gray"
                    >
                      Already have an Anchor account? Log in.
                    </LinkText>
                  )}
                  elseRender={() => (
                    <p className={`${styles.loginText} ${styles.centered}`}>
                      You can also{' '}
                      <Link
                        to="/switch"
                        onClick={events.signUpImportButtonClicked}
                      >
                        import
                      </Link>{' '}
                      an existing podcast.
                    </p>
                  )}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default SignupPage;
